(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lucie-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lucie-banner-slider')) {
  customElements.define('lucie-banner-slider', class extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.lucie-slider__slide'));
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.index = 0;
      this.timer = null;
      this.hovered = false;
      this.focused = false;
      this.paused = this.dataset.autoplay !== 'true' ||
        matchMedia('(prefers-reduced-motion: reduce)').matches ||
        Boolean(window.Shopify && window.Shopify.designMode);
      this.controls = this.querySelector('.lucie-slider__controls');
      this.toggle = this.querySelector('[data-pause]');
      this.controls.hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.show(this.index - 1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), options);
      this.toggle.addEventListener('click', () => {
        this.paused = !this.paused;
        this.updateToggle();
        this.schedule();
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', (event) => {
        this.focused = this.contains(event.relatedTarget);
        this.schedule();
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.updateToggle();
      this.schedule();
    }
    updateToggle() {
      this.toggle.textContent = this.paused ? '▶' : '❚❚';
      this.toggle.setAttribute('aria-label', this.paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      this.querySelector('[data-counter]').textContent = (this.index + 1) + ' / ' + this.slides.length;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.delay) || 5000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.abort) this.abort.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
